// generated file, if you want to edit this file manually change the word "generated" to "manual"

import MaterialLinearProgress from '@mui/material/LinearProgress';
import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForLinearProgress = makeThemedStyles('LinearProgress', () => ({
  LinearProgress: {}
}));

type PropType = React.ComponentProps<typeof MaterialLinearProgress>;

export const LinearProgress: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForLinearProgress();

  // Pick classes from the theme if they are defined
  // const theme = useTheme();
  // const themeObj = (theme as any)?.qpr?.LinearProgress
  const enabledClasses: { [key: string]: string } = {};
  const variants = ['LinearProgress'];
  Object.keys(styles || {})
    .filter(key => !variants.includes(key))
    .forEach(key => {
      if ((styles as any)[key]) {
        enabledClasses[key] = (styles as any)[key];
      }
    });

  /* eslint-disable */
  return (
    <MaterialLinearProgress
      {...props}
      classes={{
        root: styles.LinearProgress,
        ...enabledClasses
      }}
      className={clsx(styles.LinearProgress)}
    ></MaterialLinearProgress>
  );
};
export default LinearProgress;
